module.exports = __webpack_public_path__ + "static/media/goldenprizeth-tuna-soybean-lid.b2dcf033.png";